import { fetchPageAssets, fetchLandingPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchPageTranslations } from '../../containers/EditTranslationsPage/EditTranslationsPage.duck';

export const loadData = (params, search) => dispatch => {
  const pageId = params.pageId;
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;

  const promises = [
    dispatch(fetchPageAssets(pageAsset, hasFallbackContent)),
    dispatch(fetchPageTranslations(pageId)),
  ];

  // Для landscape страниц также загружаем данные главной страницы
  if (pageId && pageId.startsWith('landscape-')) {
    promises.push(dispatch(fetchLandingPageAssets()));
  }

  return Promise.all(promises);
};
